import { makeStyles } from '@material-ui/core/styles';

const boxShadow = { boxShadow: 'none' };

const useStyles = makeStyles(theme => ({
  addButton: boxShadow
}));

export default useStyles;